import { injectIntl } from 'react-intl';
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import styled from 'styled-components';
import { createStructuredSelector } from 'reselect';
import { SearchSelect } from '../../../components/SearchSelectComponent';
import { HBox, VBox } from '../../../components/Box';
import { Checkbox } from '../../../components/Checkbox';

import { Check, CircleTimes } from '../../../components/Icon';
import { CopyOptionsEdit } from './CopyOptionsEdit';

import {
  changeVehicleFilter,
  copyVehicleGeneralPhothosToTargetVehicle,
  copyVehicleOptionsToTargetVehicle,
  vehicleSearch,
} from '../actions';
import { selectWork, selectWorks } from '../../Api/selectors';
import {
  COPY_VEHICLE_GENERAL_PHOTOS_TO_TARGET_VEHICLE,
  COPY_VEHICLE_OPTIONS_TO_TARGET_VEHICLE,
  REQUEST_VEHICLE,
  REQUEST_VEHICLES,
} from '../constants';
import { parseVehicle } from '../helpers';
import _ from 'lodash';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import LoadingCard from '../../../containers/App/Components/LoadingCard/LoadingCard';

const Container = styled.div`
  min-height: 250px;
  .basic-multi-select {
    width: 100%;
    max-width: 100%;
  }
`;

const STATE = {
  string: '',
  active: false,
  options: [],
  showOptions: false,
  copySuccess: false,
};

/* eslint-disable react/prefer-stateless-function */
class VehicleCopyOptionsModalComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  doSearch() {
    if (!this.state.text) return;
    this.setState({ loading: true });
    this.props.search(this.state.text, result => {
      this.setState(
        {
          showOptions: true,
          options: result?.items?.map(parseVehicle)?.map(v => ({
            label: `${v?.regplate || ''} ${v.brand_name || ''} ${v.model_name || ''} ${
              v.power ? v.power + 'kw' : ''
            } ${v.model_info || ''}  ${v?.vin || ''}`,
            value: v?.id,
          })),
        },
        () => this.setState({ loading: false }),
      );
    });
  }

  handleKeyPress = event => {
    if (event.key === 'Enter') {
      this.props.setSearchString(this.state.search);
    }
  };

  searchStringChangeHandler(evt) {
    let text = evt;
    this.setState({ text });
    this._t = this.timeout(this.doSearch.bind(this), 1000, this._t);
  }

  reset() {
    this.setState({ ...STATE });
  }

  onSelectVehicle(value) {
    this.setState(prev => ({
      selectedVehicle: {
        value: value?.value,
        label: value?.label,
      },
      showOptions: false,
    }));
  }

  removeVehicle() {
    this.setState({ selectedVehicle: null, showOptions: true });
  }

  copyOptions() {
    if (this.props.copy_photos) {
      return this.props.copyGeneralPhotos(this.props.vehicleId, this.state.selectedVehicle?.value, result => {
        if (result.success) {
          this.setState({ copySuccess: true });
        }
      });
    }
    return this.props.copyOptions(this.props.vehicleId, this.state.selectedVehicle?.value, result => {
      this.setState({ showTargetVehicleOptions: true });
    });
  }

  render() {
    const title = this.props.copy_photos ? this.lbl('vehicle.copy_photos') : this.lbl('vehicle.copy_options');
    const label = this.lblStr(`vehicle.filter.select_vehicle`);

    return (
      <ModalComponent size={'modal-xl'} onClose={this.props.close} title={title}>
        <Container>
          <VBox left vCenter>
            <SearchSelect
              isLoading={this.props.searching || this.state.loading}
              onInputChange={e => this.searchStringChangeHandler(e)}
              closeMenuOnSelect={true}
              isDisabled={this.props.searching}
              menuIsOpen={this.state.showOptions}
              minWidth={'100%'}
              maxWidth={'100%'}
              value={this.state.selectedVehicle?.value}
              onChange={this.onSelectVehicle.bind(this)}
              placeholder={label}
              options={this.state.options}
            />
          </VBox>
          <VBox left>
            {this.state.selectedVehicle && (
              <HBox className={'mt-3'}>
                <HBox baseline left style={{ width: '60%' }}>
                  <Checkbox checked />
                  <div
                    style={{ color: '#d50046', fontSize: '20px' }}
                    onClick={() => {
                      this.removeVehicle();
                    }}
                  >
                    {' '}
                    <CircleTimes />
                  </div>
                  <p>{this.state.selectedVehicle?.label}</p>
                  {this.state.copySuccess && (
                    <div style={{ color: 'green' }}>
                      <Check />
                    </div>
                  )}
                </HBox>

                {!this.state.copySuccess && (
                  <ButtonComponent style={'ButtonSoftPrimary'} small onClick={this.copyOptions.bind(this)}>
                    {title}
                  </ButtonComponent>
                )}
              </HBox>
            )}
          </VBox>
          {this.state.showTargetVehicleOptions && !this.props.workCopyOptions && (
            <CopyOptionsEdit vehicle_id={this.props.vehicleId} />
          )}
          {this.props.workCopyOptions && <LoadingCard />}
        </Container>

        <ButtonComponent style={'ButtonSoftPrimaryFullWidth'} onClick={this.props.close}>
          {this.lbl('done')}
        </ButtonComponent>
      </ModalComponent>
    );
  }
}

VehicleCopyOptionsModalComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork(REQUEST_VEHICLES),
    workCopyOptions: selectWorks([
      REQUEST_VEHICLE,
      COPY_VEHICLE_OPTIONS_TO_TARGET_VEHICLE,
      COPY_VEHICLE_GENERAL_PHOTOS_TO_TARGET_VEHICLE,
    ]),
    searching: selectWork(REQUEST_VEHICLES),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    search(string, callback) {
      dispatch(vehicleSearch(string, callback));
    },
    setSearchString(string) {
      dispatch(changeVehicleFilter('searchString', string));
    },
    copyOptions(vehicleId, copyFromVehicleId, callback) {
      dispatch(copyVehicleOptionsToTargetVehicle(vehicleId, copyFromVehicleId, callback));
    },
    copyGeneralPhotos(vehicleId, copyFromVehicleId, callback) {
      dispatch(copyVehicleGeneralPhothosToTargetVehicle(vehicleId, copyFromVehicleId, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleCopyOptionsModal = compose(withConnect, withRouter, injectIntl)(VehicleCopyOptionsModalComp);
